import { createAction } from 'redux-actions';

const ns = 'openExternalLink/';

export const setExternalLinkToOpen = createAction<string>(`${ns}SET_EXTERNAL_LINK_TO_OPEN`);
